import { render, staticRenderFns } from "./UserProfileIcon.vue?vue&type=template&id=06b221c6"
import script from "./UserProfileIcon.vue?vue&type=script&lang=js"
export * from "./UserProfileIcon.vue?vue&type=script&lang=js"
import style0 from "./UserProfileIcon.vue?vue&type=style&index=0&id=06b221c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports